export interface PreparePackageFilter {
  shippingId: string;
  phoneNumber: string;
  dateAgendaFrom: Date;
  dateAgendaTo: Date;
  pickupAttendance: string;
}

export enum Tags {
  LOST = 'LOST',
  PREPARED = 'PREPARED',
  UNKNOWN = 'UNKNOWN',
}
